export function BloomCircle() {
  return (
    <div className="div" style={{ position: "absolute", zIndex: -1 }}>
      <div
        style={{
          position: "absolute",
          width: "300.62px",
          height: "348.92px",
          transform: "rotate(-73deg)",
          transformOrigin: "top left",
          opacity: 0.7,
          background: "rgba(56, 119, 195)",
          boxShadow: "167.41px 167.41px 167.41px rgba(77, 120, 150, 0.5)",
          filter: "blur(83.7px)",
        }}
      ></div>
    </div>
  );
}
